const color = {
    bgBlack: 'black',
    fgWhite: 'white',
    selected: 'red',
    disabled: 'grey'
};

const fontSize = {
    extraSmall: '8px',
    kindaSmall: '10px',
    verySmall: '12px',
    lessSmall: '14px',
    small: '16px',
    lessBig: '18px',
    big: '20px',
    veryBig: '24px',
    extraBig: '28px',
    huge: '32px',
    veryHuge: '36px',
    extraHuge: '40px',
    massive: '44px',
    veryMassive: '48px',
    extraMassive: '52px',
    enormous: '56px',
    veryEnormous: '60px',
    extraEnormous: '64px',
    insane: '68px',
    veryInsaane: '72px',
    extraInsane: '76px',
    gaia: '80px',
    veryGaia: '84px',
    extraGaia: '88px'
};

const padding = {
    tiny: '2px',
    // Increments of 4
    extraSmall: '4px',
    kindaSmall: '6px',
    verySmall: '8px',
    small: '12px',
    lessBig: '16px',
    // Incremenets of 8
    big : '20px',
    veryBig : '28px',
    extraBig : '36px',
    // Increments of 12
    huge: '52px',
    veryHuge: '64px',
    extraHuge: '76px',
    // Incremenets of 16
    massive: '92px',
    veryMassive: '108px',
    extraMassive: '124px',
    // Increment of 20
    enourmous: '100px',
    veryEnormous: '120px',
    extraEnormous: '140px',
    // Increment of 40
    insane: '160px',
    veryInsane: '200px',
    extraInsane: '240px'

};

const fontFamily = {
    heatwave: 'heatwaveregular',
    airwaves: 'airwavesregular',
    josefin: 'josefin_sanssemibold'
};

export { color, fontSize, fontFamily, padding };